export enum EVideoResolution {
  Max = 'maxresdefault',
  HQ = 'hqdefault',
}

export function getVideoPreviewUrl(videoId: string, resolution: EVideoResolution) {
  return `https://img.youtube.com/vi/${videoId}/${resolution}.jpg`;
}
